import PropTypes from 'prop-types';
import React from 'react';

import { FaCheck } from 'react-icons/fa';

import * as S from './Checkbox.styles';

export const Checkbox = ({
  disabled,
  isChecked,
  hasError,
  text,
  onClick,
  isRequired,
  isNegative,
}) => {
  if (!onClick || !text) {
    return null;
  }

  return (
    <S.CheckboxContainer onClick={onClick}>
      <S.HiddenCheckbox
        checked={isChecked}
        disabled={disabled}
        type='checkbox'
      />
      <S.StyledCheckbox
        checked={isChecked}
        disabled={disabled}
        onClick={onClick}
        isNegative={isNegative}
      >
        {isChecked && <FaCheck />}
      </S.StyledCheckbox>
      <S.StyledLabel
        isNegative={isNegative}
        disabled={disabled}
        hasError={hasError}
      >
        {text}
        {isRequired ? ' *' : ''}
      </S.StyledLabel>
    </S.CheckboxContainer>
  );
};

Checkbox.propTypes = {
  /**
   * Disable the checkbox.
   */
  disabled: PropTypes.bool,
  /**
   * Display the label in red if true.
   */
  hasError: PropTypes.bool,
  /**
   * Set the input to checked if true.
   */
  isChecked: PropTypes.bool,
  /**
   * Text is white and the input has no borders.
   */
  isNegative: PropTypes.bool,
  /**
   * Set the input to required if true
   */
  isRequired: PropTypes.bool,
  /**
   * Method triggered on click.
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Description of this checkbox.
   */
  text: PropTypes.string.isRequired,
};

Checkbox.defaultProps = {
  isChecked: false,
  isNegative: false,
  hasError: false,
  onClick: null,
  text: null,
};
